// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BadgeList_wrapper__17SzI","block":"BadgeList_block__3oohY","badges":"BadgeList_badges__1CpJm","title":"BadgeList_title__2Nowu"};